import { Slider } from '@change/ds-forms';
import type { SliderProps } from '@change/ds-forms';

import { AmountInput } from '../../AmountInput';
import { ValidationErrorMessage } from '../ValidationErrorMessage';

import { useSliderAmountSelector } from './hooks/useSliderAmountSelector';

type SliderAmountSelectorProps = {
	layout?: SliderProps['layout'];
};

export function SliderAmountSelector({ layout = 'labelsInline' }: SliderAmountSelectorProps): JSX.Element {
	const {
		data: { amount, currencySymbol, placeholder, maxValue, minValue, errorMessage },
		actions: { formatValue, onSliderChange, onSliderChangeEnd, onInputChange, onInputFocus },
	} = useSliderAmountSelector();

	return (
		<div className="mx-auto mt-2 w-full max-w-2xl">
			<div>
				<Slider
					data-qa="slider-amount-selector"
					// TODO: Translate this during productization
					ariaLabel="Amount"
					layout={layout}
					showTooltip
					value={amount}
					onChange={onSliderChange}
					onChangeEnd={onSliderChangeEnd}
					minValue={minValue}
					maxValue={maxValue}
					formatValue={formatValue}
					name="amountSlider"
					tooltipAlignment="follow"
				/>
			</div>
			<div className="-mt-2">
				<AmountInput
					currencySymbol={currencySymbol}
					errorMessage={errorMessage}
					onChange={onInputChange}
					onFocus={onInputFocus}
					value={amount}
					placeholder={placeholder}
					height="56px"
				/>
			</div>
			<ValidationErrorMessage />
		</div>
	);
}
